import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditRoutineModal } from '../../../utils/routes/modals/modalsActions'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'

const Header = () => {
  const { entities } = useModalData() || {}
  const openNewRoutineModal = useOpenEditRoutineModal()
  const context = 'routines'
  const canCreateRoutines = useSessionPermission('createRoutine')
  const { t } = useTranslation('routines')

  return (
    <Grid gap={0.6} align="center">
      <Col>
        <Icon name={'RiCalendar2Line'} color="dark3" size={1.4} />
      </Col>
      <Col>
        <Title size="h4" noMargin>
          {t('title', { context })}
        </Title>
      </Col>

      <Col flex={1} />

      {canCreateRoutines && (
        <Col>
          <Link onClick={() => openNewRoutineModal({ entities })}>
            <IconText
              label={t('new', { context })}
              size="small"
              iconSize="1rem"
              iconName="BsFillPlusCircleFill"
              color={COLORS.purple}
              noWrap
            />
          </Link>
        </Col>
      )}
    </Grid>
  )
}

export default Header
